// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"4df5f4c7","918":"16b72dff"}[chunkId] + ".chunk.js";
};